import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxLoadingModule } from 'ngx-loading';

import * as firebase from 'firebase';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HeaderComponent } from './header/header.component';
import { AllUsersComponent } from './all-users/all-users.component';
import { NewUsersComponent } from './new-users/new-users.component';
import { AllComplaintsComponent } from './all-complaints/all-complaints.component';
import { AllSponsersComponent } from './all-sponsers/all-sponsers.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { PostsComponent } from './posts/posts.component';
import { SubmitBannerComponent } from './submit-banner/submit-banner.component';
import { SendNotificationComponent } from './send-notification/send-notification.component';

var config = {
  apiKey: "AIzaSyBXl4Rsvnc1gDu6y6N_0nrWpfr6Wqh87xA",
  authDomain: "jumpq-app.firebaseapp.com",
  databaseURL: "https://jumpq-app.firebaseio.com",
  projectId: "jumpq-app",
  storageBucket: "jumpq-app.appspot.com",
  messagingSenderId: "88939641092"
};
firebase.initializeApp(config);

const appRoutes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'dashboard', component: DashboardComponent },
  /* { path: 'all-users', component: AllUsersComponent }, */
  { path: 'posts/:month', component: PostsComponent },
  { path: 'posts', component: PostsComponent },
  { path: 'users/:month', component: NewUsersComponent },
  { path: 'users', component: NewUsersComponent },
  { path: 'all-complaints/:month', component: AllComplaintsComponent },
  { path: 'all-complaints', component: AllComplaintsComponent },
  { path: 'all-sponsers', component: AllSponsersComponent },
  { path: 'add-sponsor/:id', component: SubmitBannerComponent },
  { path: 'add-sponsor', component: SubmitBannerComponent },
  { path: 'send-notification', component: SendNotificationComponent },
  { path: 'user-profile/:id', component: UserProfileComponent },


  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/dashboard', pathMatch: 'full' },
];

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ForgotPasswordComponent,
    DashboardComponent,
    HeaderComponent,
    AllUsersComponent,
    NewUsersComponent,
    AllComplaintsComponent,
    AllSponsersComponent,
    UserProfileComponent,
    PostsComponent,
    SubmitBannerComponent,
    SendNotificationComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    ),
    NgxLoadingModule.forRoot({
      fullScreenBackdrop: true
    }),
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
